var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"tw-title-font tw-text-2xl tw-font-medium tw-leading-6 sm:tw-py-0.5 sm:tw-text-3xl",class:_vm.textColor},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }